import { FC, CSSProperties } from "react";
import { Input } from "@src/lib/ui/Input";
import { cn } from "@src/lib/utils/cn";
import SearchIcon from "@src/lib/icons/18px/search";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  onFocus?: () => void;
  style?: CSSProperties;
  autoFocus?: boolean;
};

const SearchBar: FC<Props> = (props: Props) => {
  const {
    value,
    onChange,
    onKeyDown,
    placeholder = "Search",
    className,
    inputClassName,
    onFocus,
    style,
    autoFocus,
  } = props;

  return (
    <div
      className={cn("min-w-0 flex-grow p-0 max-w-[500px]", className)}
      style={style}
    >
      <div className="relative">
        <SearchIcon className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-gray-6" />
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={onFocus}
          autoFocus={autoFocus}
          onKeyDown={onKeyDown}
          inputClassName={cn("pl-8", inputClassName)}
        />
      </div>
    </div>
  );
};

export default SearchBar;
